import styled from "styled-components";

export default styled.div`
  color: ${props => (props.color ? props.color : props.theme.colors.primary)};
  padding: 20px 20px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-style: normal;
  font-weight: normal;
  font-size: 15px;

  span {
    font-size: 15px;
    color: #777777;
    font-weight: normal;
    margin-left: 35px;
    vertical-align: middle;
  }

  @media (max-width: 1024px) {
    span {
      display: none;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/nekrasovka-ui/CustomDialog/DialogTitle.js